import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import withPathItems from "../graphql/withPathItems"
import * as PathUI from "../ui/PathUI"
import PreviewPathDivider from "./PreviewPathDivider"
import PreviewPathLesson from "./PreviewPathLesson"
import PreviewPathResource from "./PreviewPathResource"
import PreviewPathStep from "./PreviewPathStep"

const PreviewPathList = (props) => {
  return (
    <PathUI.PathListCointainer>
      {props.error ? (
        <BlankSlate
          icons={null}
          heading="An unexpected error occurred"
          body={(props.error && props.error.message) || props.error}
          inverted
        />
      ) : props.loading && !props.items ? (
        <LoadingCircle inverted />
      ) : (
        <PathUI.PathListWrapper>
          {props.items.map((pathItem) => (
            <li key={pathItem.id}>
              <PathUI.PathItemWrapper>
                {pathItem.type === "divider" ? (
                  <PreviewPathDivider pathItem={pathItem} />
                ) : pathItem.type === "lesson" ? (
                  <PreviewPathLesson pathItem={pathItem} />
                ) : pathItem.type === "resource" ? (
                  <PreviewPathResource pathItem={pathItem} layout="list" />
                ) : pathItem.type === "step" ? (
                  <PreviewPathStep pathItem={pathItem} />
                ) : null}
              </PathUI.PathItemWrapper>
            </li>
          ))}
        </PathUI.PathListWrapper>
      )}
    </PathUI.PathListCointainer>
  )
}

PreviewPathList.displayName = "PreviewPathList"

PreviewPathList.propTypes = {
  id: PropTypes.number,
  cohort_id: PropTypes.number
}

export default withPathItems(PreviewPathList)
